// src/redux/store.js
import { createStore, compose } from "redux";
import rootReducer from "./rootReducer";

// If you want middleware later, add here. For now we'll just use plain store.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(
  // applyMiddleware(...middleware) // add middleware here
));

export default store;
